
import Vue, {VueConstructor} from 'vue'
import FilterStateMixin from '~/mixins/filter-state.mixin'
import ResponsiveMixin from '~/mixins/responsive.mixin'
import QueryMixin from '~/mixins/query.mixin'

export default (Vue as VueConstructor<Vue & InstanceType<typeof FilterStateMixin> & InstanceType<typeof ResponsiveMixin> & InstanceType<typeof QueryMixin>>).extend({
  name: 'ChefBookFilter',
  mixins: [FilterStateMixin, ResponsiveMixin, QueryMixin],
  head: {
    bodyAttrs: {
      class: 'bg-white text-offBlack'
    }
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    minGuests: {
      type: Number,
      required: true,
    },
    maxGuests: {
      type: Number,
      required: true,
    },
    blockedDates: {
      type: Array,
      required: false,
    }
  },
  computed: {
    timeSlots: () => {
      const hours = [
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
      ];

      return hours.reduce<string[]>((slots, hour) => {
        slots.push(`${hour}:00`);
        slots.push(`${hour}:15`);
        slots.push(`${hour}:30`);
        slots.push(`${hour}:45`);

        return slots;
      }, []).concat('21:00');
    }
  }
})
